/* eslint-disable no-magic-numbers */

import { Component, Input } from '@angular/core';

@Component({
    selector: 'nova-lead-rating-icon',
    templateUrl: './lead-rating-icon.component.html',
    styleUrls: ['./lead-rating-icon.component.scss']
})
export class LeadRatingIconComponent {
    @Input() leadRating = '';
    public get iconCount(): number {
        let iCount = 0;
        switch (this.leadRating) {
            case 'Hot':
                iCount = 1;
                break;
            case 'Hotter':
                iCount = 2;
                break;
            case 'Hottest':
                iCount = 3;
                break;
            default:
                iCount = 0;
                break;
        }
        return iCount;
    }
}
